import { Box, Icon, IconVariant } from '@rbilabs/universal-components';
import { CardTypes, IPaymentMethod } from 'features/payment/types';
import { ResponsiveValue } from 'native-base/lib/typescript/components/types';
import { ISizes } from 'native-base/lib/typescript/theme/base/sizes';

import { primitive } from 'styles/constants';

const getCreditCardType = (paymentMethod: IPaymentMethod | undefined) => {
  const creditCardType = paymentMethod?.credit?.cardType.toLocaleUpperCase();
  if (creditCardType === 'MC') {
    return CardTypes.MASTERCARD;
  }

  return creditCardType as CardTypes;
};

const getIconProps = (paymentMethod: IPaymentMethod | undefined, bordered: boolean) => {
  const iconPropsMap: { title: string; variant: IconVariant; isSelected: boolean }[] = [
    {
      title: 'Visa',
      variant: bordered ? 'visa' : 'visaNoBorder',
      isSelected: getCreditCardType(paymentMethod) === CardTypes.VISA,
    },
    {
      title: 'Mastercard',
      variant: bordered ? 'mastercard' : 'mastercardNoBorder',
      isSelected: getCreditCardType(paymentMethod) === CardTypes.MASTERCARD,
    },
    {
      title: 'American Express',
      variant: bordered ? 'amex' : 'amexNoBorder',
      isSelected: getCreditCardType(paymentMethod) === CardTypes.AMEX,
    },
    {
      title: 'Discover',
      variant: bordered ? 'discover' : 'discoverNoBorder',
      isSelected: getCreditCardType(paymentMethod) === CardTypes.DISCOVER,
    },
    {
      title: 'JCB',
      variant: bordered ? 'jcb' : 'jcbNoBorder',
      isSelected: getCreditCardType(paymentMethod) === CardTypes.JCB,
    },
    {
      title: 'Diners',
      variant: bordered ? 'diners' : 'dinersNoBorder',
      isSelected: getCreditCardType(paymentMethod) === CardTypes.DINERS,
    },
    {
      title: 'Google Pay',
      variant: 'googlePayBrand',
      isSelected: getCreditCardType(paymentMethod) === CardTypes.GOOGLE_PAY,
    },
    {
      title: 'Apple Pay',
      variant: bordered ? 'applepay' : 'applepayNoBorder',
      isSelected: getCreditCardType(paymentMethod) === CardTypes.APPLE_PAY,
    },
    {
      title: 'Paypal',
      variant: bordered ? 'paypal' : 'paypalNoBorder',
      isSelected: !!paymentMethod?.paypal,
    },
    {
      title: 'Venmo',
      variant: bordered ? 'venmo' : 'venmoNoBorder',
      isSelected: !!paymentMethod?.venmo,
    },
    {
      title: 'Cash',
      variant: bordered ? 'cash' : 'cashNoBorder',
      isSelected: !!paymentMethod?.cash,
    },
    {
      title: 'Cash App',
      variant: bordered ? 'cashApp' : 'cashAppNoBorder',
      isSelected: !!paymentMethod?.cashapp,
    },
    {
      title: 'Gift Card',
      variant: bordered ? 'giftCard' : 'giftCardNoBorder',
      isSelected: !!paymentMethod?.prepaid,
    },
  ];

  return iconPropsMap.find(iconProps => iconProps.isSelected);
};

const BlankCard = Box.withConfig({
  backgroundColor: primitive.$greyFour,
  height: '$5',
  width: '$6',
});

type PaymentMethodIconProps = {
  paymentMethod: IPaymentMethod | undefined;
  size?: ResponsiveValue<ISizes | (string & {}) | number>;
  bordered?: boolean;
};
export function PaymentMethodIcon({
  paymentMethod,
  bordered = false,
  size = 'lg',
}: PaymentMethodIconProps) {
  const iconProps = getIconProps(paymentMethod, bordered);
  if (!iconProps) {
    return <BlankCard />;
  }

  return <Icon accessibilityHidden {...iconProps} size={size} />;
}
